export default {"src":"/_next/static/media/nut-free.925561d6.svg","height":16,"width":16};